import { createSlice } from "@reduxjs/toolkit";
import { setSocket } from "./adminSlice";

const initialStateList = {
  user_id: "",
  email: "",
  name: "",
  role: "",
  userDetails: {},
  // socket: null,
};

const userSlice = createSlice({
  name: "user",
  initialState: initialStateList,
  reducers: {
    setUser: (state, action) => {
      return { ...state, ...action.payload };
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setSocketDetails: (state, action) => {
      state.socket = action.payload;
    },
    clearUser: () => initialStateList,
    clearSocket: () => (state, action) => {
      state.socket.close();
      state.socket = null;
    },
  },
});

export const {
  setUser,
  setUserDetails,
  clearUser,
  setSocketDetails,
  clearSocket,
} = userSlice.actions;

export default userSlice.reducer;
